angular.module("bot").directive("ngGetBotMeta", ($log, $interval) => {
  return {
    restrict: "A",
    link: scope => {
      scope.onGotCallbackFunction = () => {
        if(!WRP || !WRP.BotMetadata){
          console.warn("[ngGetBotMeta] global module WRP is not defined or missing WRP.BotMetadata");
        }        
        WRP.BotMetadata.get()
          .then(
            response => {
              scope.onBotMetaCallback(response);
              // because promise is resolved outside of angularjs, apply changes to the scope
              if (!scope.$$phase) {
                scope.$apply();
              }
            },
            rejectResponse => {
              console.warn("[ngGetBotMeta] WRP.BotMetadata.get() failed with:", rejectResponse)
            }
          );
      };

      // @NOTE shares scope with the parent, in which method onBotMetaCallback must exist for this to continue
      // in practice scope.onBotMetaCallback is already present and so this works first time
      let attempts = 5;
      const intervalPromise = $interval(() => {
        if (scope.onBotMetaCallback) {
          $interval.cancel(intervalPromise);
          scope.onGotCallbackFunction();
          return;
        } else {
          console.error("scope.onBotMetaCallback method is missing");
        }

        attempts--;
        if (attempts < 1) {
          $interval.cancel(intervalPromise);
          $log.warn("[ng-get-bot-meta] Could not find callback function");
        }
      }, 50);

    }
  };
});